export const EA_URI = Object.freeze({
  AUTOMATION_API: 'ea/automation',
  FEDRAMP_DOMAIN: 'usg1.exposure-analytics.insight.rapid7-gov.com',
  PROD_DOMAIN: 'exposure-analytics.insight.rapid7.com',
  STAGING_DOMAIN: 'exposure-analytics.ivm-staging.r7ops.com',
});

export default Object.freeze({EA_URI});
